import { extractTermPaths } from 'lib/taxonomy';

const getInlineNewsletterConfig = (
  article,
  newsletterData = [],
) => {
  const {
    taxonomy = [],
  } = article;

  const termPaths = extractTermPaths(taxonomy);

  const isInList = (list) => termPaths.some((path) => list.includes(path));

  const newsletter = newsletterData.filter((config) => {
    const {
      excludedTaxonomyPaths = [],
      includedTaxonomyPaths = [],
    } = config;
    return !isInList(excludedTaxonomyPaths) && isInList(includedTaxonomyPaths);
  });

  // in case multiple items match above filtering, we only want to return first config
  // TOOD: (BENTO-15008) Implement specificity logic in the case of multiple configs returned
  if (newsletter.length >= 1) return newsletter[0];

  return null;
};

export { getInlineNewsletterConfig };
